import React, { createContext } from 'react';
import { VideoPlayerConfig } from '../configs';
export const AnalyticsContext = createContext({
    setDefaultPlayerConfig: () => { },
    defaultPlayerConfig: VideoPlayerConfig,
    getVideoElement: () => Promise.resolve(document.createElement('video')),
});
export function AnalyticsProvider({ defaultPlayer, defaultTimeInterval, children, }) {
    const [defaultPlayerConfig, setDefaultPlayerConfig] = React.useState(defaultPlayer || VideoPlayerConfig);
    async function getVideoElement(player, config = defaultPlayerConfig) {
        return config.getVideoElement(player);
    }
    return (<AnalyticsContext.Provider value={{
            defaultPlayerConfig,
            defaultTimeInterval,
            setDefaultPlayerConfig,
            getVideoElement,
        }}>
      {children}
    </AnalyticsContext.Provider>);
}
